import React from 'react';
import Container from '../../layouts/Container';
import { Box, Flex, Image, Img, List, ListItem } from '@chakra-ui/react';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';

const Wrapper = styled(Box)`
	margin-top: 118px;
`;

const listDesc = [
	{
		key: 'computer',
		title: 'Trading Volume: $1B USD',
	},
	{
		key: 'global',
		title: 'Supported Country Worldwide',
	},
	{
		key: 'cup',
		title: '03 years of experience',
	},
];

const SafeAndSecure = () => {
	const { t } = useTranslation('translation', {
		keyPrefix: 'Home.SafeAndSecure',
	});
	return (
		<Wrapper>
			<Container>
				<Flex
					flexDirection={{ base: 'column', md: 'row-reverse' }}
					justifyContent={'space-between'}
				>
					<Box data-aos="fade-left" data-aos-duration={'1500'}>
						<Img src="/images/homepage/safeAndsecure.png" />
					</Box>
					<Box
						maxW={'548px'}
						textAlign={{ base: 'center', md: 'left' }}
						data-aos="fade-right"
						data-aos-duration={'1500'}
					>
						<Box fontSize={'30px'} lineHeight={'48px'} mb={'8px'}>
							{t('Safe & Secure')}
						</Box>
						<Box color="#737283">{t('desc')}</Box>

						<List data-aos="fade-right" data-aos-duration={'1500'}>
							{listDesc.map((desc, index) => (
								<ListItem
									key={desc.key}
									display={'flex'}
									alignItems={'center'}
									my={'34px'}
									textAlign={'left'}
								>
									<Box mr={'30px'}>
										<Image src={`/images/homepage/${desc.key}-icon.svg`} />
									</Box>
									<Box fontSize={{ base: '18px', md: '24px' }} maxW={'412px'}>
										{t(`title${index + 1}`)}
									</Box>
								</ListItem>
							))}
						</List>
					</Box>
				</Flex>
			</Container>
		</Wrapper>
	);
};

export default SafeAndSecure;
